/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_BacklogInputs */

const en_status_backlog = /** @type {(inputs: Status_BacklogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backlog`)
};

const de_status_backlog = /** @type {(inputs: Status_BacklogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backlog`)
};

/**
* | output |
* | --- |
* | "Backlog" |
*
* @param {Status_BacklogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_backlog = /** @type {((inputs?: Status_BacklogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_BacklogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_status_backlog(inputs)
	return en_status_backlog(inputs)
});